/* DropConvert Theme JS */
/* Modular, vanilla JS — no external dependencies */

(function() {
  'use strict';

  /* ===========================
     CART DRAWER
  =========================== */
  var CartDrawer = {
    drawer: null,
    trigger: null,
    closeBtn: null,
    overlay: null,
    countEl: null,
    subtotalEl: null,
    bodyEl: null,

    init: function() {
      this.drawer = document.getElementById('cart-drawer');
      this.trigger = document.getElementById('cart-drawer-trigger');
      this.closeBtn = document.getElementById('cart-drawer-close');
      this.overlay = document.getElementById('cart-drawer-overlay');
      this.countEl = document.getElementById('cart-count');
      this.subtotalEl = document.getElementById('cart-drawer-subtotal');
      this.bodyEl = document.getElementById('cart-drawer-body');
      if (!this.drawer) return;
      if (this.trigger) this.trigger.addEventListener('click', this.open.bind(this));
      if (this.closeBtn) this.closeBtn.addEventListener('click', this.close.bind(this));
      if (this.overlay) this.overlay.addEventListener('click', this.close.bind(this));
      document.addEventListener('keydown', function(e) { if (e.key === 'Escape') CartDrawer.close(); });
      document.addEventListener('cart:open', this.open.bind(this));
      this.bindItemActions();
      this.bindFooterLinks();
    },

    open: function() {
      if (!this.drawer) return;
      this.drawer.hidden = false;
      this.drawer.setAttribute('aria-hidden', 'false');
      setTimeout(function() { CartDrawer.drawer.classList.add('open'); }, 10);
      document.body.style.overflow = 'hidden';
      if (this.closeBtn) this.closeBtn.focus();
    },

    close: function() {
      if (!this.drawer) return;
      this.drawer.classList.remove('open');
      setTimeout(function() {
        CartDrawer.drawer.hidden = true;
        CartDrawer.drawer.setAttribute('aria-hidden', 'true');
      }, 300);
      document.body.style.overflow = '';
    },

    updateCount: function(count) {
      var els = document.querySelectorAll('#cart-count, #cart-drawer-count');
      els.forEach(function(el) { el.textContent = count; });
    },

    refresh: function() {
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          CartDrawer.updateCount(cart.item_count);
          if (CartDrawer.subtotalEl) {
            CartDrawer.subtotalEl.textContent = formatMoney(cart.total_price);
          }
          CartDrawer.renderBody(cart);
        });
    },

    renderBody: function(cart) {
      if (!this.bodyEl) return;
      if (!cart || !Array.isArray(cart.items) || cart.items.length === 0) {
        this.bodyEl.innerHTML = '<p class="cart-drawer__empty">Your cart is empty.</p>';
        return;
      }

      var html = cart.items.map(function(item, index) {
        var line = index + 1;
        var image = item.image ? item.image : '';
        var variantTitle = item.variant_title && item.variant_title !== 'Default Title'
          ? '<p class="cart-drawer__item-variant">' + escapeHtml(item.variant_title) + '</p>'
          : '';

        return '' +
          '<div class="cart-drawer__item" data-line="' + line + '" data-product-id="' + item.product_id + '" data-variant-id="' + item.variant_id + '">' +
            '<a href="' + item.url + '" class="cart-drawer__item-image-link">' +
              '<img src="' + image + '" alt="' + escapeHtml(item.product_title) + '" width="96" height="96" loading="lazy" class="cart-drawer__item-image">' +
            '</a>' +
            '<div class="cart-drawer__item-info">' +
              '<div class="cart-drawer__item-meta">' +
                '<a href="' + item.url + '" class="cart-drawer__item-title">' + escapeHtml(item.product_title) + '</a>' +
                '<div class="cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</div>' +
              '</div>' +
              variantTitle +
              '<div class="cart-drawer__item-controls">' +
                '<div class="cart-drawer__qty-pill" aria-label="Quantity">' +
                '<button class="cart-drawer__qty-btn" type="button" data-action="decrease" aria-label="Decrease quantity">' +
                  '<svg class="icon icon--minus" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="5" y1="12" x2="19" y2="12"></line></svg>' +
                '</button>' +
                '<span class="cart-drawer__qty-val">' + item.quantity + '</span>' +
                '<button class="cart-drawer__qty-btn" type="button" data-action="increase" aria-label="Increase quantity">' +
                  '<svg class="icon icon--plus" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>' +
                '</button>' +
                '</div>' +
                '<button class="cart-drawer__remove" type="button" data-action="remove" aria-label="Remove item">' +
                  'Remove' +
                '</button>' +
              '</div>' +
            '</div>' +
          '</div>';
      }).join('');

      this.bodyEl.innerHTML = html;
    },

    addItem: function(variantId, qty, callback) {
      qty = qty || 1;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (data.id) {
          CartDrawer.refresh();
          CartDrawer.open();
          if (callback) callback(data);
          document.dispatchEvent(new CustomEvent('cart:item-added', { detail: data }));
        }
      })
      .catch(function(err) { console.warn('Cart add error:', err); });
    },

    addItems: function(items, callback) {
      if (!Array.isArray(items) || !items.length) return;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        CartDrawer.refresh();
        CartDrawer.open();
        if (callback) callback(data);
        document.dispatchEvent(new CustomEvent('cart:item-added', { detail: data }));
      })
      .catch(function(err) { console.warn('Cart add batch error:', err); });
    },

    bindItemActions: function() {
      var body = this.bodyEl;
      if (!body) return;
      body.addEventListener('click', function(e) {
        var btn = e.target.closest('[data-action]');
        if (!btn) return;
        var item = btn.closest('.cart-drawer__item');
        if (!item) return;
        var line = parseInt(item.dataset.line);
        var action = btn.dataset.action;
        var qtyEl = item.querySelector('.cart-drawer__qty-val');
        var currentQty = qtyEl ? parseInt(qtyEl.textContent) : 1;
        var newQty = action === 'increase' ? currentQty + 1 : action === 'decrease' ? Math.max(0, currentQty - 1) : 0;
        CartDrawer.updateLine(line, newQty, item, qtyEl);
      });
    },

    bindFooterLinks: function() {
      var checkoutLink = document.querySelector('.cart-drawer__checkout');
      var viewCartLink = document.querySelector('.cart-drawer__view-cart');
      if (checkoutLink) {
        checkoutLink.addEventListener('click', function(e) {
          e.preventDefault();
          var checkoutUrl = checkoutLink.getAttribute('href') || '/checkout';
          CartDrawer.close();
          window.location.assign(checkoutUrl);
        });
      }
      if (viewCartLink) {
        viewCartLink.addEventListener('click', function(e) {
          e.preventDefault();
          var cartUrl = viewCartLink.getAttribute('href') || '/cart';
          CartDrawer.close();
          window.location.assign(cartUrl);
        });
      }
    },

    updateLine: function(line, qty, itemEl, qtyEl) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        CartDrawer.updateCount(cart.item_count);
        if (CartDrawer.subtotalEl) CartDrawer.subtotalEl.textContent = formatMoney(cart.total_price);
        CartDrawer.renderBody(cart);
      });
    }
  };

  /* ===========================
     STICKY ADD TO CART
  =========================== */
  var StickyATC = {
    el: null,
    atcSection: null,
    threshold: 0,

    init: function() {
      this.el = document.getElementById('sticky-atc');
      if (!this.el) return;
      var productMain = document.getElementById('product-main');
      if (!productMain) return;
      this.atcSection = productMain;
      window.addEventListener('scroll', this.onScroll.bind(this), { passive: true });
    },

    onScroll: function() {
      if (!this.atcSection) return;
      var rect = this.atcSection.getBoundingClientRect();
      var pastSection = rect.bottom < 0;
      if (pastSection) {
        this.el.classList.add('visible');
        this.el.setAttribute('aria-hidden', 'false');
      } else {
        this.el.classList.remove('visible');
        this.el.setAttribute('aria-hidden', 'true');
      }
    }
  };

  /* ===========================
     VARIANT SELECTION
  =========================== */
  var VariantSelector = {
    product: null,
    variants: null,
    selectedOptions: [],

    init: function() {
      if (!window.productData) return;
      this.product = window.productData;
      this.variants = window.productVariants || this.product.variants;
      if (!this.variants || !this.variants.length) return;

      var firstVariant = this.variants[0];
      this.selectedOptions = firstVariant ? firstVariant.options.slice() : [];

      var optionBtns = document.querySelectorAll('.product-main__option-btn');
      optionBtns.forEach(function(btn) {
        btn.addEventListener('click', function() {
          var idx = parseInt(btn.closest('[data-option-index]').dataset.optionIndex);
          var val = btn.dataset.value;
          VariantSelector.selectOption(idx, val, btn.closest('.product-main__option-values'));
        });
      });

      var optionSelects = document.querySelectorAll('.product-main__option-select');
      optionSelects.forEach(function(select) {
        select.addEventListener('change', function() {
          var idx = parseInt(select.dataset.optionIndex, 10);
          if (!Number.isFinite(idx)) return;
          VariantSelector.selectOption(idx, select.value, null);
        });
      });

      var productForm = document.getElementById('product-form');
      if (productForm) {
        productForm.addEventListener('submit', function(e) {
          e.preventDefault();
          var variantId = document.getElementById('variant-id').value;
          var qtyHidden = document.getElementById('product-qty-hidden');
          var qty = qtyHidden ? parseInt(qtyHidden.value, 10) : 1;
          qty = Number.isFinite(qty) && qty > 0 ? qty : 1;

          var offerItems = OfferSelector.getSelectedVariantItems(VariantSelector.selectedOptions, VariantSelector.variants);
          if (offerItems && offerItems.length) {
            CartDrawer.addItems(offerItems);
          } else {
            CartDrawer.addItem(variantId, qty);
          }
        });
      }

      var buyNowBtn = document.getElementById('buy-now-btn');
      if (buyNowBtn) {
        buyNowBtn.addEventListener('click', function() {
          var variantId = document.getElementById('variant-id').value;
          var qtyHidden = document.getElementById('product-qty-hidden');
          var qty = qtyHidden ? parseInt(qtyHidden.value, 10) : 1;
          qty = Number.isFinite(qty) && qty > 0 ? qty : 1;

          var offerItems = OfferSelector.getSelectedVariantItems(VariantSelector.selectedOptions, VariantSelector.variants);
          var lineItems = [];
          if (offerItems && offerItems.length) {
            lineItems = offerItems
              .filter(function(item) { return item && item.id; })
              .map(function(item) {
                var itemQty = parseInt(item.quantity, 10);
                itemQty = Number.isFinite(itemQty) && itemQty > 0 ? itemQty : 1;
                return String(item.id) + ':' + String(itemQty);
              });
          } else if (variantId) {
            lineItems = [String(variantId) + ':' + String(qty)];
          }

          if (!lineItems.length) return;
          window.location.href = '/cart/' + lineItems.join(',') + '?checkout';
        });
      }

      var stickyAtcBtn = document.getElementById('sticky-atc-btn');
      if (stickyAtcBtn) {
        stickyAtcBtn.addEventListener('click', function() {
          var variantId = document.getElementById('variant-id').value;
          CartDrawer.addItem(variantId, 1);
        });
      }
    },

    selectOption: function(index, value, container) {
      this.selectedOptions[index] = value;
      if (container) {
        container.querySelectorAll('.product-main__option-btn').forEach(function(b) {
          var isSelected = b.dataset.value === value;
          b.classList.toggle('selected', isSelected);
          b.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
        });
      }
      this.updateVariant();
    },

    findVariant: function() {
      var opts = this.selectedOptions;
      return this.variants.find(function(v) {
        return v.options.every(function(o, i) { return o === opts[i]; });
      });
    },

    updateVariant: function() {
      var variant = this.findVariant();
      if (!variant) return;

      var variantInput = document.getElementById('variant-id');
      if (variantInput) {
        variantInput.value = variant.id;
        variantInput.dataset.variantId = variant.id;
      }

      /* Update price displays */
      var price = variant.price;
      var compareAt = variant.compare_at_price;
      var priceEls = document.querySelectorAll('[data-product-price]');
      priceEls.forEach(function(el) {
        var html = '';
        if (compareAt && compareAt > price) {
          html = '<span class="price__sale">' + formatMoney(price) + '</span>' +
                 '<span class="price__compare"><s>' + formatMoney(compareAt) + '</s></span>';
        } else {
          html = '<span class="price__regular">' + formatMoney(price) + '</span>';
        }
        el.innerHTML = html;
      });

      /* Update sticky ATC price */
      var stickyPrice = document.getElementById('sticky-atc-price');
      if (stickyPrice) stickyPrice.innerHTML = formatMoney(price);

      /* Update ATC buttons data-variant-id */
      document.querySelectorAll('[data-variant-id]').forEach(function(el) {
        el.dataset.variantId = variant.id;
      });

      document.querySelectorAll('.product-main__option-select').forEach(function(select) {
        var idx = parseInt(select.dataset.optionIndex, 10);
        if (!Number.isFinite(idx)) return;
        if (variant.options && typeof variant.options[idx] !== 'undefined') {
          select.value = variant.options[idx];
        }
      });

      /* Update gallery image if variant has image */
      if (variant.featured_image || variant.featured_media || variant.image_id) {
        VariantSelector.updateGalleryImage(variant);
      }

      /* Toggle ATC availability */
      var atcBtn = document.getElementById('add-to-cart-btn');
      if (atcBtn) {
        atcBtn.disabled = !variant.available;
        atcBtn.classList.toggle('btn--disabled', !variant.available);
        atcBtn.classList.toggle('btn--primary', variant.available);
        atcBtn.textContent = variant.available ? 'Add to Cart' : 'Out of Stock';
      }

      var buyNowBtn = document.getElementById('buy-now-btn');
      if (buyNowBtn) {
        buyNowBtn.disabled = !variant.available;
      }
    },

    updateGalleryImage: function(variant) {
      var gallery = document.getElementById('product-gallery');
      if (!gallery) return;

      var items = gallery.querySelectorAll('.product-gallery__item');
      if (!items.length) return;

      var thumbs = document.querySelectorAll('.product-gallery__thumb');
      var targetIndex = -1;

      var imageId = null;
      if (variant && variant.featured_image && variant.featured_image.id) {
        imageId = String(variant.featured_image.id);
      } else if (variant && variant.featured_media && variant.featured_media.id) {
        imageId = String(variant.featured_media.id);
      } else if (variant && variant.image_id) {
        imageId = String(variant.image_id);
      }

      if (imageId) {
        items.forEach(function(item, index) {
          if (String(item.dataset.imageId || '') === imageId) {
            targetIndex = index;
          }
        });
      }

      if (targetIndex < 0) {
        var src = '';
        if (variant && variant.featured_image && variant.featured_image.src) {
          src = variant.featured_image.src;
        } else if (variant && variant.featured_media && variant.featured_media.preview_image && variant.featured_media.preview_image.src) {
          src = variant.featured_media.preview_image.src;
        }

        if (src) {
          var getToken = function(url) {
            var file = String(url || '').split('?')[0].split('#')[0].split('/').pop();
            return file.replace(/_(\d+x\d*|x\d+)(?=\.[^.]+$)/, '');
          };

          var targetToken = getToken(src);
          items.forEach(function(item, index) {
            var img = item.querySelector('.product-gallery__img');
            if (img && getToken(img.src) === targetToken) {
              targetIndex = index;
            }
          });
        }
      }

      if (targetIndex < 0 && variant && Array.isArray(variant.options) && variant.options.length) {
        var normalize = function(value) {
          return String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, '');
        };

        var optionCandidates = [];
        variant.options.forEach(function(opt) {
          var full = String(opt || '').trim();
          if (!full) return;
          optionCandidates.push(full);
          var firstWord = full.split(/\s+/)[0];
          if (firstWord && firstWord.toLowerCase() !== full.toLowerCase()) {
            optionCandidates.push(firstWord);
          }
        });

        items.forEach(function(item, index) {
          if (targetIndex >= 0) return;
          var img = item.querySelector('.product-gallery__img');
          if (!img) return;
          var haystack = normalize((img.alt || '') + ' ' + img.src);

          optionCandidates.some(function(candidate) {
            var needle = normalize(candidate);
            if (needle && haystack.indexOf(needle) !== -1) {
              targetIndex = index;
              return true;
            }
            return false;
          });
        });
      }

      if (targetIndex < 0) {
        targetIndex = 0;
      }

      items.forEach(function(item, index) {
        item.classList.toggle('active', index === targetIndex);
      });
      thumbs.forEach(function(thumb, index) {
        thumb.classList.toggle('active', index === targetIndex);
      });
    }
  };

  /* ===========================
     OFFER SELECTOR (PRODUCT)
  =========================== */
  var OfferSelector = {
    init: function() {
      var wrap = document.getElementById('offer-selector');
      if (!wrap) return;
      var cards = wrap.querySelectorAll('.product-main__offer-card');
      var qtyInput = document.getElementById('product-qty');
      var qtyHiddenInput = document.getElementById('product-qty-hidden');
      if (!cards.length || !qtyHiddenInput) return;

      function selectCard(card) {
        cards.forEach(function(c) { c.classList.remove('is-selected'); });
        cards.forEach(function(c) { c.setAttribute('aria-pressed', 'false'); });
        card.classList.add('is-selected');
        card.setAttribute('aria-pressed', 'true');
        cards.forEach(function(c) {
          c.querySelectorAll('[data-offer-options]').forEach(function(opts) {
            opts.classList.add('is-hidden');
          });
        });
        card.querySelectorAll('[data-offer-options]').forEach(function(opts) {
          opts.classList.remove('is-hidden');
        });
        var qty = parseInt(card.dataset.offerQty || '1', 10);
        var safeQty = qty > 0 ? qty : 1;
        qtyHiddenInput.value = safeQty;
        if (qtyInput) qtyInput.value = safeQty;
      }

      function selectSwatch(swatch) {
        var optionIndex = parseInt(swatch.dataset.optionIndex, 10);
        var value = swatch.dataset.value;
        if (!Number.isFinite(optionIndex) || !value) return;

        var slot = swatch.closest('[data-offer-swatch-slot]');
        if (slot) {
          slot.querySelectorAll('[data-offer-swatch]').forEach(function(el) {
            el.classList.toggle('is-selected', el.dataset.value === value);
          });
        }

        if (window.DropConvert && window.DropConvert.VariantSelector && typeof window.DropConvert.VariantSelector.selectOption === 'function') {
          var optionGroup = document.querySelector('.product-main__option[data-option-index="' + optionIndex + '"] .product-main__option-values');
          window.DropConvert.VariantSelector.selectOption(optionIndex, value, optionGroup);
        }
      }

      cards.forEach(function(card, index) {
        card.addEventListener('click', function() { selectCard(card); });
        card.addEventListener('keydown', function(e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            selectCard(card);
          }
        });
        if (index === 0 && !wrap.querySelector('.product-main__offer-card.is-selected')) {
          selectCard(card);
        }
      });

      wrap.querySelectorAll('[data-offer-swatch]').forEach(function(swatch) {
        swatch.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          selectSwatch(swatch);
        });
      });
    },

    getSelectedVariantItems: function(baseOptions, variants) {
      var wrap = document.getElementById('offer-selector');
      if (!wrap || !Array.isArray(baseOptions) || !Array.isArray(variants)) return null;
      var activeCard = wrap.querySelector('.product-main__offer-card.is-selected');
      if (!activeCard) return null;

      var colorOptionIndex = parseInt(activeCard.dataset.colorOptionIndex, 10);
      if (!Number.isFinite(colorOptionIndex) || colorOptionIndex < 0) return null;

      var slots = activeCard.querySelectorAll('[data-offer-swatch-slot]');
      if (!slots.length) return null;

      var counts = {};
      slots.forEach(function(slot) {
        var selected = slot.querySelector('[data-offer-swatch].is-selected') || slot.querySelector('[data-offer-swatch]');
        if (!selected) return;
        var selectedValue = selected.dataset.value;
        if (!selectedValue) return;

        var options = baseOptions.slice();
        options[colorOptionIndex] = selectedValue;
        var match = variants.find(function(v) {
          return v.options.every(function(o, idx) { return o === options[idx]; });
        });
        if (!match) return;
        counts[match.id] = (counts[match.id] || 0) + 1;
      });

      var items = Object.keys(counts).map(function(id) {
        return { id: parseInt(id, 10), quantity: counts[id] };
      }).filter(function(item) { return Number.isFinite(item.id) && item.quantity > 0; });

      return items.length ? items : null;
    }
  };

  /* ===========================
     PRODUCT GALLERY
  =========================== */
  var ProductGallery = {
    init: function() {
      var gallery = document.getElementById('product-gallery');
      if (!gallery) return;
      var thumbsContainer = document.getElementById('product-gallery-thumbs');
      var prevBtn = document.getElementById('product-thumbs-prev');
      var nextBtn = document.getElementById('product-thumbs-next');
      var thumbs = document.querySelectorAll('.product-gallery__thumb');

      function updateNavState() {
        if (!thumbsContainer || !prevBtn || !nextBtn) return;
        var maxScrollLeft = thumbsContainer.scrollWidth - thumbsContainer.clientWidth;
        prevBtn.disabled = thumbsContainer.scrollLeft <= 2;
        nextBtn.disabled = thumbsContainer.scrollLeft >= (maxScrollLeft - 2);
      }

      function scrollThumbIntoView(thumb) {
        if (!thumb || !thumbsContainer) return;
        thumb.scrollIntoView({ behavior: 'smooth', inline: 'nearest', block: 'nearest' });
      }

      thumbs.forEach(function(thumb) {
        thumb.addEventListener('click', function() {
          var idx = parseInt(thumb.dataset.index);
          ProductGallery.showSlide(idx);
          thumbs.forEach(function(t) { t.classList.remove('active'); });
          thumb.classList.add('active');
          scrollThumbIntoView(thumb);
          updateNavState();
        });
      });

      if (thumbsContainer && prevBtn && nextBtn) {
        function getStep() {
          var firstThumb = thumbsContainer.querySelector('.product-gallery__thumb');
          return firstThumb ? (firstThumb.offsetWidth + 8) * 3 : 240;
        }

        prevBtn.addEventListener('click', function() {
          thumbsContainer.scrollBy({ left: -getStep(), behavior: 'smooth' });
        });
        nextBtn.addEventListener('click', function() {
          thumbsContainer.scrollBy({ left: getStep(), behavior: 'smooth' });
        });

        thumbsContainer.addEventListener('scroll', updateNavState, { passive: true });
        window.addEventListener('resize', updateNavState, { passive: true });
        updateNavState();
      }

      /* Image zoom on desktop hover */
      var imgs = gallery.querySelectorAll('.product-gallery__img[data-zoom]');
      imgs.forEach(function(img) {
        img.addEventListener('mouseenter', function() {
          if (window.innerWidth > 768) {
            img.style.cursor = 'zoom-in';
          }
        });
        img.addEventListener('click', function() {
          var zoomSrc = img.dataset.zoom;
          if (zoomSrc) {
            var overlay = document.createElement('div');
            overlay.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,0.9);z-index:9999;display:flex;align-items:center;justify-content:center;cursor:zoom-out;';
            var zoomImg = document.createElement('img');
            zoomImg.src = zoomSrc;
            zoomImg.style.cssText = 'max-width:90vw;max-height:90vh;object-fit:contain;border-radius:8px;';
            overlay.appendChild(zoomImg);
            overlay.addEventListener('click', function() { document.body.removeChild(overlay); });
            document.body.appendChild(overlay);
          }
        });
      });
    },

    showSlide: function(idx) {
      var items = document.querySelectorAll('.product-gallery__item');
      var thumbs = document.querySelectorAll('.product-gallery__thumb');
      items.forEach(function(item, i) {
        item.classList.toggle('active', i === idx);
      });
      thumbs.forEach(function(thumb, i) {
        thumb.classList.toggle('active', i === idx);
      });
    }
  };

  /* ===========================
     FAQ ACCORDION
  =========================== */
  var FAQ = {
    init: function() {
      var questions = document.querySelectorAll('.faq__question');
      questions.forEach(function(btn) {
        btn.addEventListener('click', function() {
          var expanded = btn.getAttribute('aria-expanded') === 'true';
          var answerId = btn.getAttribute('aria-controls');
          var answer = document.getElementById(answerId);
          if (!answer) return;
          btn.setAttribute('aria-expanded', !expanded);
          answer.hidden = expanded;
        });
      });
    }
  };

  /* ===========================
     PRODUCT FAQ (SMOOTH DETAILS)
  =========================== */
  var ProductFAQ = {
    init: function() {
      var items = document.querySelectorAll('.product-main__faq-item');
      if (!items.length) return;

      items.forEach(function(item) {
        var summary = item.querySelector('.product-main__faq-question');
        var content = item.querySelector('.product-main__faq-answer');
        if (!summary || !content) return;

        if (item.open) {
          content.style.height = 'auto';
        } else {
          content.style.height = '0px';
        }

        summary.addEventListener('click', function(e) {
          e.preventDefault();
          if (item.dataset.animating === 'true') return;
          item.dataset.animating = 'true';

          var isOpen = item.open;

          if (isOpen) {
            var startHeight = content.getBoundingClientRect().height;
            content.style.height = startHeight + 'px';
            content.style.opacity = '1';
            content.offsetHeight;

            requestAnimationFrame(function() {
              content.style.height = '0px';
              content.style.opacity = '0';
            });

            var onCloseEnd = function(evt) {
              if (evt.propertyName !== 'height') return;
              content.removeEventListener('transitionend', onCloseEnd);
              item.open = false;
              item.dataset.animating = 'false';
            };
            content.addEventListener('transitionend', onCloseEnd);
          } else {
            item.open = true;
            content.style.height = '0px';
            content.style.opacity = '0';
            var endHeight = content.scrollHeight;
            content.offsetHeight;

            requestAnimationFrame(function() {
              content.style.height = endHeight + 'px';
              content.style.opacity = '1';
            });

            var onOpenEnd = function(evt) {
              if (evt.propertyName !== 'height') return;
              content.removeEventListener('transitionend', onOpenEnd);
              content.style.height = 'auto';
              item.dataset.animating = 'false';
            };
            content.addEventListener('transitionend', onOpenEnd);
          }
        });
      });
    }
  };

  /* ===========================
     QUANTITY SELECTOR
  =========================== */
  var QuantitySelector = {
    init: function() {
      var minus = document.getElementById('qty-minus');
      var plus = document.getElementById('qty-plus');
      var input = document.getElementById('product-qty');
      var hiddenInput = document.getElementById('product-qty-hidden');
      if (!minus || !plus || !input || !hiddenInput) return;

      function syncHidden() {
        var parsed = parseInt(input.value, 10);
        var safe = Number.isFinite(parsed) && parsed > 0 ? Math.min(99, parsed) : 1;
        input.value = safe;
        hiddenInput.value = safe;
      }

      minus.addEventListener('click', function() {
        var val = Math.max(1, parseInt(input.value) - 1);
        input.value = val;
        hiddenInput.value = val;
      });
      plus.addEventListener('click', function() {
        var val = Math.min(99, parseInt(input.value) + 1);
        input.value = val;
        hiddenInput.value = val;
      });
      input.addEventListener('change', syncHidden);
      syncHidden();
    }
  };

  /* ===========================
     CART PAGE QTY STEPPER
  =========================== */
  var CartPageQuantity = {
    init: function() {
      var btns = document.querySelectorAll('[data-cart-qty-delta]');
      if (!btns.length) return;

      btns.forEach(function(btn) {
        btn.addEventListener('click', function() {
          var targetId = btn.getAttribute('data-target-input');
          var input = targetId ? document.getElementById(targetId) : null;
          if (!input) return;

          var delta = parseInt(btn.getAttribute('data-cart-qty-delta'), 10);
          var current = parseInt(input.value, 10);
          var safeCurrent = Number.isFinite(current) ? current : 1;
          var next = safeCurrent + (Number.isFinite(delta) ? delta : 0);
          if (next < 0) next = 0;
          if (next > 999) next = 999;
          input.value = next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    }
  };

  /* ===========================
     REVIEWS CAROUSEL
  =========================== */
  var ReviewsCarousel = {
    track: null,
    slides: null,
    current: 0,
    autoplayInterval: null,
    itemsPerPage: 3,

    init: function() {
      this.track = document.getElementById('reviews-carousel');
      if (!this.track) return;
      this.slides = this.track.querySelectorAll('.reviews-carousel__slide');
      if (this.slides.length === 0) return;

      var dotsContainer = document.getElementById('reviews-dots');
      var prevBtn = document.getElementById('reviews-prev');
      var nextBtn = document.getElementById('reviews-next');

      if (prevBtn) prevBtn.addEventListener('click', this.prev.bind(this));
      if (nextBtn) nextBtn.addEventListener('click', this.next.bind(this));

      /* Determine mobile single or 3-col on desktop */
      this.updateItemsPerPage();
      window.addEventListener('resize', this.updateItemsPerPage.bind(this), { passive: true });

      /* Build dots */
      if (dotsContainer) {
        var pageCount = Math.ceil(this.slides.length / this.itemsPerPage);
        for (var i = 0; i < pageCount; i++) {
          var dot = document.createElement('button');
          dot.className = 'reviews-carousel__dot' + (i === 0 ? ' active' : '');
          dot.setAttribute('role', 'tab');
          dot.setAttribute('aria-label', 'Review page ' + (i + 1));
          dot.dataset.idx = i;
          dot.addEventListener('click', (function(idx) { return function() { ReviewsCarousel.goTo(idx); }; })(i));
          dotsContainer.appendChild(dot);
        }
      }

      /* Autoplay */
      if (this.track.dataset.autoplay === 'true') {
        this.autoplayInterval = setInterval(this.next.bind(this), 4000);
      }
    },

    updateItemsPerPage: function() {
      this.itemsPerPage = window.innerWidth <= 768 ? 1 : window.innerWidth <= 1024 ? 2 : 3;
    },

    goTo: function(idx) {
      this.current = idx;
      var offset = idx * 100;
      /* Simple approach: hide/show groups */
      this.slides.forEach(function(slide, i) {
        slide.style.display = 'none';
      });
      var start = idx * this.itemsPerPage;
      for (var j = start; j < Math.min(start + this.itemsPerPage, this.slides.length); j++) {
        this.slides[j].style.display = '';
      }
      var dots = document.querySelectorAll('.reviews-carousel__dot');
      dots.forEach(function(d, i) { d.classList.toggle('active', i === idx); });
    },

    prev: function() {
      var pages = Math.ceil(this.slides.length / this.itemsPerPage);
      this.goTo((this.current - 1 + pages) % pages);
    },

    next: function() {
      var pages = Math.ceil(this.slides.length / this.itemsPerPage);
      this.goTo((this.current + 1) % pages);
    }
  };

  /* ===========================
     CATEGORIES SLIDER
  =========================== */
  var CategoriesSlider = {
    init: function() {
      var roots = document.querySelectorAll('[data-categories-slider]');
      roots.forEach(function(root) {
        var viewport = root.querySelector('[data-categories-viewport]');
        var track = root.querySelector('[data-categories-track]');
        var slides = Array.prototype.slice.call(root.querySelectorAll('.category-slider__slide'));
        var prevBtn = root.querySelector('[data-categories-prev]');
        var nextBtn = root.querySelector('[data-categories-next]');
        var dotsWrap = root.querySelector('[data-categories-dots]');
        if (!viewport || !track || slides.length === 0) return;

        var state = { index: 0, itemsPerPage: 3, positions: 1 };

        function getItemsPerPage() {
          var width = window.innerWidth;
          if (width <= 768) return 1;
          if (width <= 1024) return 2;
          return 3;
        }

        function updateButtonState() {
          if (prevBtn) prevBtn.disabled = state.index <= 0;
          if (nextBtn) nextBtn.disabled = state.index >= state.positions - 1;
        }

        function renderDots() {
          if (!dotsWrap) return;
          dotsWrap.innerHTML = '';
          for (var i = 0; i < state.positions; i++) {
            var dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'category-slider__dot' + (i === state.index ? ' is-active' : '');
            dot.setAttribute('aria-label', 'Category slide ' + (i + 1));
            dot.addEventListener('click', (function(idx) {
              return function() {
                state.index = idx;
                applyPosition();
              };
            })(i));
            dotsWrap.appendChild(dot);
          }
          dotsWrap.style.display = state.positions > 1 ? '' : 'none';
        }

        function applyPosition() {
          var targetSlide = slides[state.index];
          var offset = targetSlide ? targetSlide.offsetLeft : 0;
          track.style.transform = 'translateX(' + (-offset) + 'px)';
          if (dotsWrap) {
            var dots = dotsWrap.querySelectorAll('.category-slider__dot');
            dots.forEach(function(dot, idx) {
              dot.classList.toggle('is-active', idx === state.index);
            });
          }
          updateButtonState();
        }

        function recalc() {
          state.itemsPerPage = getItemsPerPage();
          state.positions = Math.max(1, slides.length - state.itemsPerPage + 1);
          if (state.index >= state.positions) state.index = state.positions - 1;
          renderDots();
          applyPosition();
          var hasOverflow = state.positions > 1;
          if (prevBtn) prevBtn.style.display = hasOverflow ? '' : 'none';
          if (nextBtn) nextBtn.style.display = hasOverflow ? '' : 'none';
        }

        if (prevBtn) {
          prevBtn.addEventListener('click', function() {
            if (state.index > 0) {
              state.index -= 1;
              applyPosition();
            }
          });
        }
        if (nextBtn) {
          nextBtn.addEventListener('click', function() {
            if (state.index < state.positions - 1) {
              state.index += 1;
              applyPosition();
            }
          });
        }

        recalc();
        window.addEventListener('resize', recalc, { passive: true });
      });
    }
  };

  /* ===========================
     NEW ARRIVALS SLIDER
  =========================== */
  var NewArrivalsSlider = {
    init: function() {
      var roots = document.querySelectorAll('[data-new-arrivals-slider]');
      roots.forEach(function(root) {
        var viewport = root.querySelector('[data-new-arrivals-viewport]');
        var track = root.querySelector('[data-new-arrivals-track]');
        var slides = Array.prototype.slice.call(root.querySelectorAll('.new-arrivals__slide'));
        var prevBtn = root.querySelector('[data-new-arrivals-prev]');
        var nextBtn = root.querySelector('[data-new-arrivals-next]');
        if (!viewport || !track || slides.length === 0) return;

        var state = { index: 0, itemsPerPage: 4, positions: 1 };

        function getItemsPerPage() {
          var width = window.innerWidth;
          if (width <= 768) return 1;
          if (width <= 1024) return 2;
          return 4;
        }

        function updateButtonState() {
          if (prevBtn) prevBtn.disabled = state.index <= 0;
          if (nextBtn) nextBtn.disabled = state.index >= state.positions - 1;
        }

        function applyPosition() {
          var targetSlide = slides[state.index];
          var offset = targetSlide ? targetSlide.offsetLeft : 0;
          track.style.transform = 'translateX(' + (-offset) + 'px)';
          updateButtonState();
        }

        function recalc() {
          state.itemsPerPage = getItemsPerPage();
          state.positions = Math.max(1, slides.length - state.itemsPerPage + 1);
          if (state.index >= state.positions) state.index = state.positions - 1;
          applyPosition();
          var hasOverflow = state.positions > 1;
          if (prevBtn) prevBtn.style.display = hasOverflow ? '' : 'none';
          if (nextBtn) nextBtn.style.display = hasOverflow ? '' : 'none';
        }

        if (prevBtn) {
          prevBtn.addEventListener('click', function() {
            if (state.index > 0) {
              state.index -= 1;
              applyPosition();
            }
          });
        }
        if (nextBtn) {
          nextBtn.addEventListener('click', function() {
            if (state.index < state.positions - 1) {
              state.index += 1;
              applyPosition();
            }
          });
        }

        recalc();
        window.addEventListener('resize', recalc, { passive: true });
      });
    }
  };

  /* ===========================
     TRENDING GRID FILTERS
  =========================== */
  var TrendingGridFilters = {
    init: function() {
      var roots = document.querySelectorAll('[data-trending-grid]');
      roots.forEach(function(root) {
        var toolbar = root.querySelector('[data-trending-toolbar]');
        var grid = root.querySelector('[data-trending-products]');
        var emptyEl = root.querySelector('[data-trending-empty]');
        if (!toolbar || !grid) return;

        var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-product-card-wrapper]'));
        var sortLabel = root.querySelector('[data-sort-label]');
        var baseMinPrice = Number(root.dataset.priceMin || 0);
        var baseMaxPrice = Number(root.dataset.priceMax || 0);
        var state = {
          availability: [],
          colors: [],
          tags: [],
          sizes: [],
          priceMin: baseMinPrice,
          priceMax: baseMaxPrice,
          sort: 'featured'
        };

        function parseList(str) {
          if (!str) return [];
          return str.split('|').map(function(item) { return item.trim().toLowerCase(); }).filter(Boolean);
        }

        function intersects(productValues, selectedValues) {
          if (!selectedValues.length) return true;
          for (var i = 0; i < selectedValues.length; i++) {
            if (productValues.indexOf(selectedValues[i]) !== -1) return true;
          }
          return false;
        }

        function sortCards() {
          cards.sort(function(a, b) {
            var aPrice = Number(a.dataset.price || 0);
            var bPrice = Number(b.dataset.price || 0);
            var aCreated = Number(a.dataset.createdAt || 0);
            var bCreated = Number(b.dataset.createdAt || 0);
            var aPosition = Number(a.dataset.position || 0);
            var bPosition = Number(b.dataset.position || 0);

            if (state.sort === 'price-asc') return aPrice - bPrice;
            if (state.sort === 'price-desc') return bPrice - aPrice;
            if (state.sort === 'newest') return bCreated - aCreated;
            if (state.sort === 'best-selling') return aPosition - bPosition;
            return aPosition - bPosition;
          });
          cards.forEach(function(card) { grid.appendChild(card); });
        }

        function applyFilters() {
          sortCards();
          var visibleCount = 0;
          cards.forEach(function(card) {
            var availability = (card.dataset.available || '').toLowerCase();
            var price = Number(card.dataset.price || 0) / 100;
            var tags = parseList(card.dataset.tags || '');
            var colors = parseList(card.dataset.colors || '');
            var sizes = parseList(card.dataset.sizes || '');

            var isVisible = true;
            if (state.availability.length && state.availability.indexOf(availability) === -1) isVisible = false;
            if (isVisible && !intersects(tags, state.tags)) isVisible = false;
            if (isVisible && !intersects(colors, state.colors)) isVisible = false;
            if (isVisible && !intersects(sizes, state.sizes)) isVisible = false;
            if (isVisible && Number.isFinite(state.priceMin) && price < state.priceMin) isVisible = false;
            if (isVisible && Number.isFinite(state.priceMax) && price > state.priceMax) isVisible = false;

            card.style.display = isVisible ? '' : 'none';
            if (isVisible) visibleCount += 1;
          });
          if (emptyEl) emptyEl.hidden = visibleCount > 0;
        }

        function closeAllPanels(exceptFilter) {
          var filters = toolbar.querySelectorAll('.trending-grid__filter');
          filters.forEach(function(filter) {
            if (exceptFilter && filter === exceptFilter) return;
            filter.classList.remove('is-open');
          });
        }

        toolbar.querySelectorAll('.trending-grid__filter').forEach(function(filter) {
          var key = filter.dataset.filterKey;
          var toggle = filter.querySelector('[data-filter-toggle]');
          var panel = filter.querySelector('[data-filter-panel]');
          var applyBtn = filter.querySelector('[data-filter-apply]');
          var clearBtn = filter.querySelector('[data-filter-clear]');
          if (!toggle || !panel) return;

          toggle.addEventListener('click', function(e) {
            e.preventDefault();
            var nextOpen = !filter.classList.contains('is-open');
            closeAllPanels(filter);
            filter.classList.toggle('is-open', nextOpen);
          });

          if (applyBtn) {
            applyBtn.addEventListener('click', function() {
              if (key === 'price') {
                var minInput = filter.querySelector('[data-price-min]');
                var maxInput = filter.querySelector('[data-price-max]');
                var nextMin = minInput ? Number(minInput.value) : baseMinPrice;
                var nextMax = maxInput ? Number(maxInput.value) : baseMaxPrice;
                if (!Number.isFinite(nextMin) || nextMin < 0) nextMin = baseMinPrice;
                if (!Number.isFinite(nextMax) || nextMax < 0) nextMax = baseMaxPrice;
                if (nextMin > nextMax) {
                  var temp = nextMin;
                  nextMin = nextMax;
                  nextMax = temp;
                }
                state.priceMin = nextMin;
                state.priceMax = nextMax;
              } else {
                var checked = Array.prototype.slice.call(filter.querySelectorAll('input[type="checkbox"]:checked'))
                  .map(function(input) { return input.value.toLowerCase(); });
                if (key === 'availability') state.availability = checked;
                if (key === 'color') state.colors = checked;
                if (key === 'tags') state.tags = checked;
                if (key === 'size') state.sizes = checked;
              }
              filter.classList.remove('is-open');
              applyFilters();
            });
          }

          if (clearBtn) {
            clearBtn.addEventListener('click', function() {
              if (key === 'price') {
                var minInput = filter.querySelector('[data-price-min]');
                var maxInput = filter.querySelector('[data-price-max]');
                if (minInput) minInput.value = baseMinPrice;
                if (maxInput) maxInput.value = baseMaxPrice;
                state.priceMin = baseMinPrice;
                state.priceMax = baseMaxPrice;
              } else {
                filter.querySelectorAll('input[type="checkbox"]').forEach(function(input) { input.checked = false; });
                if (key === 'availability') state.availability = [];
                if (key === 'color') state.colors = [];
                if (key === 'tags') state.tags = [];
                if (key === 'size') state.sizes = [];
              }
              applyFilters();
            });
          }

          if (key === 'sort') {
            filter.querySelectorAll('input[type="radio"]').forEach(function(radio) {
              radio.addEventListener('change', function() {
                state.sort = radio.value;
                if (sortLabel) {
                  var textNode = radio.closest('label') ? radio.closest('label').innerText : 'Featured';
                  sortLabel.textContent = textNode.trim();
                }
                filter.classList.remove('is-open');
                applyFilters();
              });
            });
          }
        });

        document.addEventListener('click', function(e) {
          if (root.contains(e.target) && e.target.closest('.trending-grid__filter')) return;
          closeAllPanels();
        });

        applyFilters();
      });
    }
  };

  /* ===========================
     STICKY OFFSETS
  =========================== */
  var StickyOffsets = {
    init: function() {
      var announcementSection = document.getElementById('shopify-section-announcement-bar');
      var headerSection = document.getElementById('shopify-section-header');

      function getVisibleHeight(el) {
        if (!el) return 0;
        var styles = window.getComputedStyle(el);
        if (styles.display === 'none' || styles.visibility === 'hidden') return 0;
        var rect = el.getBoundingClientRect();
        if (rect.bottom <= 0) return 0;
        return rect.height > 0 ? rect.height : 0;
      }

      function updateStickyOffsetVar() {
        var offset = 0;
        offset += getVisibleHeight(announcementSection);
        offset += getVisibleHeight(headerSection);
        document.documentElement.style.setProperty('--sticky-header-offset', offset + 'px');
      }

      updateStickyOffsetVar();
      window.addEventListener('resize', updateStickyOffsetVar, { passive: true });
      window.addEventListener('scroll', updateStickyOffsetVar, { passive: true });
      window.addEventListener('orientationchange', updateStickyOffsetVar, { passive: true });

      if ('ResizeObserver' in window) {
        var ro = new ResizeObserver(updateStickyOffsetVar);
        if (announcementSection) ro.observe(announcementSection);
        if (headerSection) ro.observe(headerSection);
      }
    }
  };

  /* ===========================
     MOBILE MENU
  =========================== */
  var MobileMenu = {
    init: function() {
      var btn = document.getElementById('mobile-menu-btn');
      var nav = document.getElementById('mobile-nav');
      var overlay = document.getElementById('mobile-nav-overlay');
      if (!btn || !nav) return;
      var announcementSection = document.getElementById('shopify-section-announcement-bar');
      var headerSection = document.getElementById('shopify-section-header');

      function getVisibleHeight(el) {
        if (!el) return 0;
        var styles = window.getComputedStyle(el);
        if (styles.display === 'none' || styles.visibility === 'hidden') return 0;
        var rect = el.getBoundingClientRect();
        return rect.height > 0 ? rect.height : 0;
      }

      function updateNavOffset() {
        var offset = 0;
        offset += getVisibleHeight(announcementSection);
        offset += getVisibleHeight(headerSection);
        nav.style.top = offset + 'px';
        nav.style.height = 'calc(100% - ' + offset + 'px)';
      }

      function setOpen(open) {
        updateNavOffset();
        nav.classList.toggle('open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        nav.setAttribute('aria-hidden', open ? 'false' : 'true');
        document.body.style.overflow = open ? 'hidden' : '';
      }

      btn.addEventListener('click', function() {
        var open = !nav.classList.contains('open');
        setOpen(open);
      });

      if (overlay) {
        overlay.addEventListener('click', function() { setOpen(false); });
      }

      nav.addEventListener('click', function(e) {
        if (e.target.closest('a')) setOpen(false);
      });

      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') setOpen(false);
      });

      updateNavOffset();
      window.addEventListener('resize', updateNavOffset, { passive: true });
      window.addEventListener('scroll', updateNavOffset, { passive: true });
      window.addEventListener('orientationchange', updateNavOffset, { passive: true });

      if ('ResizeObserver' in window) {
        var ro = new ResizeObserver(updateNavOffset);
        if (announcementSection) ro.observe(announcementSection);
        if (headerSection) ro.observe(headerSection);
      }
    }
  };

  /* ===========================
     COLLECTION FILTERS
  =========================== */
  var CollectionFilters = {
    init: function() {
      var desktopDropdowns = document.querySelectorAll('.collection-filter-dropdown');
      var openBtn = document.getElementById('collection-filter-open');
      var closeBtn = document.getElementById('collection-filter-close');
      var applyBtn = document.getElementById('collection-filter-apply');
      var overlay = document.getElementById('collection-filter-overlay');
      var drawer = document.getElementById('collection-mobile-drawer');

      /* Desktop: allow only one open dropdown */
      if (desktopDropdowns.length) {
        desktopDropdowns.forEach(function(dropdown) {
          dropdown.addEventListener('toggle', function() {
            if (!dropdown.open) return;
            desktopDropdowns.forEach(function(other) {
              if (other !== dropdown) other.open = false;
            });
          });
        });

        document.addEventListener('click', function(e) {
          if (e.target.closest('.collection-filter-dropdown')) return;
          desktopDropdowns.forEach(function(dropdown) { dropdown.open = false; });
        });
      }

      function setOpen(open) {
        if (!drawer) return;
        drawer.classList.toggle('open', open);
        drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
        document.body.style.overflow = open ? 'hidden' : '';
      }

      if (openBtn && drawer) openBtn.addEventListener('click', function() { setOpen(true); });
      if (closeBtn && drawer) closeBtn.addEventListener('click', function() { setOpen(false); });
      if (overlay && drawer) overlay.addEventListener('click', function() { setOpen(false); });
      if (applyBtn && drawer) applyBtn.addEventListener('click', function() { setOpen(false); });

      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
          setOpen(false);
          if (desktopDropdowns.length) {
            desktopDropdowns.forEach(function(dropdown) { dropdown.open = false; });
          }
        }
      });

      /* Auto-apply price filters after user input */
      var priceInputs = document.querySelectorAll(
        '.collection-filter-dropdown__price-form input[name="filter.v.price.gte"], ' +
        '.collection-filter-dropdown__price-form input[name="filter.v.price.lte"], ' +
        '.collection-mobile-filter__price input[name="filter.v.price.gte"], ' +
        '.collection-mobile-filter__price input[name="filter.v.price.lte"]'
      );
      var priceSubmitTimer = null;

      function submitPriceForm(inputEl) {
        var form = inputEl && inputEl.closest('form');
        if (!form) return;
        if (priceSubmitTimer) clearTimeout(priceSubmitTimer);
        priceSubmitTimer = setTimeout(function() {
          form.submit();
        }, 500);
      }

      if (priceInputs.length) {
        priceInputs.forEach(function(input) {
          input.addEventListener('input', function() { submitPriceForm(input); });
          input.addEventListener('change', function() { submitPriceForm(input); });
        });
      }
    }
  };

  /* ===========================
     UPSELL TIMER
  =========================== */
  var UpsellTimer = {
    init: function() {
      var timerEl = document.getElementById('upsell-timer');
      if (!timerEl) return;
      var minutes = parseInt(timerEl.dataset.duration) || 15;
      var seconds = minutes * 60;
      var displayEl = document.getElementById('upsell-timer-display');
      var interval = setInterval(function() {
        seconds--;
        if (seconds <= 0) { clearInterval(interval); if (timerEl) timerEl.textContent = 'Offer expired'; return; }
        var m = Math.floor(seconds / 60);
        var s = seconds % 60;
        if (displayEl) displayEl.textContent = m + ':' + (s < 10 ? '0' : '') + s;
      }, 1000);
    }
  };

  /* ===========================
     UPSELL MODAL
  =========================== */
  var UpsellModal = {
    modal: null,
    closeBtn: null,
    overlay: null,

    init: function() {
      this.modal = document.getElementById('upsell-modal');
      this.closeBtn = document.getElementById('upsell-modal-close');
      this.overlay = document.getElementById('upsell-modal-overlay');
      if (!this.modal) return;
      if (this.closeBtn) this.closeBtn.addEventListener('click', this.close.bind(this));
      if (this.overlay) this.overlay.addEventListener('click', this.close.bind(this));
      document.addEventListener('keydown', function(e) { if (e.key === 'Escape') UpsellModal.close(); });
      document.addEventListener('cart:item-added', this.onItemAdded.bind(this));
    },

    open: function(content) {
      if (!this.modal) return;
      var body = document.getElementById('upsell-modal-body');
      if (body && content) body.innerHTML = content;
      this.modal.hidden = false;
    },

    close: function() {
      if (!this.modal) return;
      this.modal.hidden = true;
    },

    onItemAdded: function(e) {
      /* After item added, could show upsell — fires only once per session */
      try {
        if (sessionStorage.getItem('upsell-shown')) return;
        sessionStorage.setItem('upsell-shown', '1');
      } catch(err) {}
    }
  };

  /* ===========================
     UPSELL & BUNDLE ADD
  =========================== */
  var UpsellAdd = {
    init: function() {
      document.querySelectorAll('[data-upsell-add]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var variantId = btn.dataset.variantId;
          if (!variantId) return;
          CartDrawer.addItem(variantId, 1, function() {
            btn.textContent = 'Added!';
            btn.disabled = true;
          });
        });
      });

      var bundleBtn = document.getElementById('bundle-add-btn');
      if (bundleBtn) {
        bundleBtn.addEventListener('click', function() {
          var items = document.querySelectorAll('[data-bundle-item-variant]');
          if (items.length === 0) {
            /* Fallback: add all products in bundle section */
            bundleBtn.textContent = 'Configure bundle in admin';
            return;
          }
          var promises = Array.from(items).map(function(item) {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: item.dataset.bundleItemVariant, quantity: 1 })
            }).then(function(r) { return r.json(); });
          });
          Promise.all(promises).then(function() {
            CartDrawer.refresh();
            CartDrawer.open();
          });
        });
      }
    }
  };

  /* ===========================
     LAZY IMAGES
  =========================== */
  var LazyImages = {
    init: function() {
      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting) {
              var img = entry.target;
              if (img.dataset.src) {
                img.src = img.dataset.src;
                img.classList.add('loaded');
                observer.unobserve(img);
              }
            }
          });
        });
        document.querySelectorAll('img.lazy').forEach(function(img) { observer.observe(img); });
      }
    }
  };

  /* ===========================
     ANNOUNCEMENT BAR INLINE
     (handled inline in section)
  =========================== */

  /* ===========================
     UTILITIES
  =========================== */
  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace(/[^\d-]/g, '');
    var amount = Number(cents);
    if (!Number.isFinite(amount)) amount = 0;
    var value = (amount / 100).toFixed(2);
    return '$' + value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  /* ===========================
     PRODUCT FORM (generic ATC on cards)
  =========================== */
  var GenericATC = {
    init: function() {
      document.querySelectorAll('[data-analytics="card-atc"]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          if (btn.disabled) return;
          var variantId = btn.dataset.variantId;
          if (!variantId) return;
          CartDrawer.addItem(variantId, 1);
        });
      });
    }
  };

  /* ===========================
     BOOT
  =========================== */
  document.addEventListener('DOMContentLoaded', function() {
    StickyOffsets.init();
    CartDrawer.init();
    StickyATC.init();
    CategoriesSlider.init();
    NewArrivalsSlider.init();
    TrendingGridFilters.init();
    VariantSelector.init();
    OfferSelector.init();
    ProductGallery.init();
    FAQ.init();
    ProductFAQ.init();
    QuantitySelector.init();
    CartPageQuantity.init();
    ReviewsCarousel.init();
    MobileMenu.init();
    CollectionFilters.init();
    UpsellTimer.init();
    UpsellModal.init();
    UpsellAdd.init();
    LazyImages.init();
    GenericATC.init();
  });

  /* Expose globally for app integrations */
  window.DropConvert = {
    CartDrawer: CartDrawer,
    UpsellModal: UpsellModal,
    formatMoney: formatMoney,
    VariantSelector: VariantSelector
  };

})();
